import React from 'react';

export const ProfileForm = () => {
    return (
        <div>
            ProfileForm
        </div>
    )
}